$(function () {
    $('.accordion').each(function () {
        const accordion = $(this);

        accordion.on('click', '.accordion__header', function () {
                const parent = $(this).parent(),
                    content = '.accordion__content';

            if (parent.hasClass('active')) {
                parent.removeClass('active');
                parent.children(content).slideUp(200);
            } else {
                accordion.find('.accordion__item.active')
                    .removeClass('active')
                    .children(content)
                    .slideUp(200);

                parent.addClass('active');
                parent.children(content).slideDown(200);
            }
        });
    });
});
